<template>
<div class="edit-wrapper">
  <div class="edit-form">
    <div class="ship-to">
      <!-- <el-card style="width: 100%;"> -->
        <div class="edit-title">地址簿<i @click="$emit('close-address-editor')" class="material-icons" style="color: #333;">clear</i></div>
        <div style="width:100%;padding:0 12px 2rem 12px;box-sizing:border-box;position:relative">
          <el-form :rules="rulesReceiver" :model="receiveInfo" ref="step2Form">
            <el-form-item label="别名" prop="alias">
              <el-input placeholder="为地址创建一个别名" v-model="receiveInfo.alias" clearable></el-input>
            </el-form-item>
            <el-form-item label="收件人姓名" prop="name">
              <el-input placeholder="请输入收件人姓名" v-model="receiveInfo.name" clearable></el-input>
            </el-form-item>
            <el-form-item label="手机" prop="phone">
              <el-input placeholder="收件人联系方式（例：13912341234）" type="number" v-model="receiveInfo.phone" clearable></el-input>
            </el-form-item>
            <el-form-item label="身份证号码" prop="ID">
              <el-input placeholder="收件人身份证号码" v-model="receiveInfo.ID" clearable></el-input>
            </el-form-item>
            <el-form-item label='地区' prop='province'>
              <el-row>
                <el-col :span='24' style="display:flex;">
                  <el-cascader :options="locationOption" v-model="selectedRegion" placeholder="省 / 市 / 区" style="width:100%;"></el-cascader>
                </el-col>
              </el-row>
            </el-form-item>
            <el-form-item label="详细地址" prop="addressInfo">
              <el-input placeholder="收件人详细地址" v-model="receiveInfo.addressInfo" clearable></el-input>
            </el-form-item>
            <el-form-item label="邮编" prop="postal">
              <el-input placeholder="收件人邮编" type="number" v-model="receiveInfo.postal" clearable></el-input>
            </el-form-item>
            <el-form-item label="国家" prop="country">
              <el-input placeholder="收件人国家" v-model="receiveInfo.country" disabled></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div style="width:100%;display:flex;flex-direction:row;padding:0px 12px;box-sizing:border-box; margin-bottom: 2rem">
          <el-button type="primary" @click="saveAddress">保存 <i class="el-icon-arrow-right el-icon-right"></i></el-button>
        </div>
      <!-- </el-card> -->
    </div>
  </div>
</div>
</template>

<script src="https://ajax.googleapis.com/ajax/libs/webfont/1.4.7/webfont.js" type="text/javascript"></script>
<script type="text/javascript">
import { saveAddress } from "../../../../../../GitHub/yunda-shop-system/firebase-project/app-vue-3/public/js/addressBook";

  WebFont.load({
    google: {
      families: ["Montserrat:100,100italic,200,200italic,300,300italic,400,400italic,500,500italic,600,600italic,700,700italic,800,800italic,900,900italic"]
    }
  });
</script>
<script>
import { ChinaRegion } from '../../public/js/ChinaRegion'
import { saveAddress } from '../../public/js/addressBook'

export default {
  name: 'AddressEditor',
  props: ['address'],
  data () {
    return {
      receiveInfo: this.address,
      selectedRegion: [this.address.province, this.address.city, this.address.district],
      rulesReceiver: {
        alias: [
          { required: true, message: '必须为该地址制定一个别名，例如：张三-公司', trigger: 'blur' }
        ],
        name: [
          { required: true, message: '请输入收件人姓名', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入收件人联系电话（手机）', trigger: 'blur' },
          { type: 'string', pattern: /^[0-9]*$/, message: '手机号码仅包含数字', triger: 'change' },
          { min: 11, max: 11, message: '联系方式为11位手机号码', triger: 'change' }
        ],
        addressInfo: [
          { required: true, message: '请输入详细地址', trigger: 'blur' }
        ],
        province: [
          { required: true, message: '请选择地区', trigger: 'change' }
        ],
        postal: [
          { required: true, message: '请输入邮编', trigger: 'blur' },
          { type: 'string', pattern: /^[0-9]*$/, message: '邮编仅包含数字', triger: 'change' },
          { min: 6, max: 6, message: '邮编应为6位纯数字', triger: 'change' }
        ],
        ID: [
          { required: true, message: '请输入收件人身份证号码', trigger: 'blur' },
          { type: 'string', pattern: /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}$)/, message: '请输入真实的身份证号码', triger: 'blur' }
        ]
      },
      locationOption: ChinaRegion,
      warningTxt: ''
    }
  },
  methods: {
    saveAddress: function () {
      let address = this.receiveInfo
      address.province = this.selectedRegion[0]
      address.city = this.selectedRegion[1]
      address.district = this.selectedRegion[2]
      // console.log('save address', address)
      let that = this
      return saveAddress(address).then(() => {
        // console.log('address updated')
        that.$emit('close-address-editor')
        that.$message({
          message: '地址簿已更新',
          type: 'success'
        })
      }).catch(err => {
        // console.log(err)
        that.$message({
          message: '地址簿更新失败，请稍后重试',
          type: 'danger'
        })
      })
    }
  }
}

</script>

<style scoped>
p {
    text-align: left;
}
h2 {
  font-size: 35pt;
}
.add-title {
  width:560px;
  display:flex;
  flex-direction:row;
  justify-content: space-between;
  align-items: center;
  padding:32px 0 12px 0;
  font-size:16px;
  font-weight:bold;
  border-bottom:1px solid #e0e0e0;
  box-sizing:border-box;
  position: fixed;
  top: 10vh;
  left: auto;
  right: auto;
  background-color: #ffffff;
  z-index: 1100;
}
.el-form-item {
  display: flex;
  flex-direction: column;
}
.el-form-item__label {
  position: relative;
  text-align: left !important;
}
.font-bold {
  font-weight: bold;
}
.form-header {
  padding: 0 20px;
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  box-sizing: border-box;
}
.form-footer {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: medium;
}
.back-home {
  font-size: 18px;
  color: whitesmoke;
  font-weight: normal;
  cursor: pointer;
}
.studio-s {
  margin-left: 4px;
  font-size: medium;
  color: #c62828;
  text-decoration: none;
}
.form-main {
  padding: 64px 120px;
}
.step1{
  padding-top: 56px;
  margin: auto;
  width: 90%;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}
.from-shop {
  width: 48%;
}
.from-home {
  width: 48%;
}
.step2 {
  padding-top: 56px;
  margin: auto;
  width: 90%;
}
.ship-to {
  width: 100%;
  margin: auto;
}
.step3 {
  padding-top: 56px;
  margin: auto;
  width: 90%;
}
.pack-detail {
  width: 48%;
  margin: auto;
}
.specSelect {
  width: 200px;
}
.step4 {
  padding-top: 56px;
  margin: auto;
  width: 90%;
}
.add-info {
  width: 48%;
  margin: auto;
}
.step5 {
  padding-top: 56px;
  margin: auto;
  width: 90%;
}
.confirm-info {
  width: 48%;
  margin: auto;
}
.order-success {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  background-color: rgba(77,77,77,0.4);
  z-index: 1001;
  animation: showConfirm 0.4s ease;
}
.success-info {
  color: rgba(0, 0, 0, 0.6);
  width: 800px;
  height: 70vh;
  margin: auto;
  background-image: url(../../public/images/yunda-b-6.jpg);
  background-position: left top;
  background-size: cover;
  background-repeat: no-repeat;
  border-radius: 20px;
  padding: 10px;
  box-sizing: border-box;
  box-shadow: 0 28px 50px -25px #494949;
  overflow: auto;
}
.fail-info {
  color: rgba(0, 0, 0, 0.6);
  width: 800px;
  height: 70vh;
  margin: auto;
  background-image: url(../../public/images/yunda-back.jpg);
  background-position: left top;
  background-size: cover;
  background-repeat: no-repeat;
  border-radius: 20px;
  padding: 10px;
  box-sizing: border-box;
  box-shadow: 0 28px 50px -25px #494949;
  overflow: auto;
}
.success-image {
  width: 780px;
  height: 18vh;
  border-radius: 5PX 5px 0 0;
  color: rgba(49, 49, 49, 0.2);
  font-family:'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;
  display: flex;
  align-items:flex-start;
  justify-content: flex-end;
}
.success-content {
  width: 100%;
  height: 49.5vh;
  border-radius: 0 0 5px 5px;
}
@keyframes showConfirm {
  from { opacity: 0; }
  to { opacity: 1; }
}
@media (max-width: 1440px) {
  .step1{
    width: 95%;
    margin: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .step2{
    margin: auto;
    width: 95%;
  }
  .step3{
    margin: auto;
    width: 95%;
  }
  .step4{
    margin: auto;
    width: 95%;
  }
  .step5{
    margin: auto;
    width: 95%;
  }
  .from-shop {
    width: 60%;
  }
  .from-home {
    margin-top: 16px;
    width: 60%;
  }
  .ship-to {
    width: 100%;
  }
  .pack-detail {
    width: 60%;
  }
  .add-info {
    width: 60%;
  }
  .confirm-info {
    width: 60%;
  }
  .el-card__body {
    padding: 20px 4px;
  }
}
@media (max-width: 1024px) {
  .form-main {
    padding: 24px 12px;
    font-size: small;
  }
  .step1{
    width: 95%;
    margin: auto;
    display: flex;
    flex-direction: column;
    padding-top: 24px;
  }
  .step2{
    padding-top: 24px;
    margin: auto;
    width: 95%;
  }
  .step3{
    padding-top: 24px;
    margin: auto;
    width: 95%;
  }
  .step4{
    padding-top: 24px;
    margin: auto;
    width: 95%;
  }
  .step5{
    padding-top: 24px;
    margin: auto;
    width: 95%;
  }
  .from-shop {
    width: 100%;
  }
  .from-home {
    margin-top: 16px;
    width: 100%;
  }
  .ship-to {
    width: 100%;
  }
  .pack-detail {
    width: 100%;
  }
  .add-info {
    width: 100%;
  }
  .confirm-info {
    width: 100%;
  }
  .el-card__body {
    padding: 20px 4px;
  }
}
@media (max-width: 812px) {
  .specSelect {
    width: 80px;
  }
  .el-message-box {
    width: 300px;
  }
  .el-step__title {
    font-size: 14px;
  }
  .success-info {
  color: rgba(0, 0, 0, 0.6);
  width: 95%;
  height: 95vh;
  margin: auto;
  background:url(../../public/images/yunda-b-7.jpg);
  background-size: right;
  background-position: left top;
  background-size: cover;
  background-repeat: no-repeat;
  border-radius: 20px;
  padding: 10px;
  box-sizing: border-box;
  box-shadow: 0 28px 50px -25px #494949;
  display: flex;
  flex-direction: column;
  overflow: auto;
}
.success-image {
  width: 100%;
  border-radius: 5PX 5px 0 0;
  color: rgba(49, 49, 49, 0.2);
  font-family:'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;
  display: flex;
  align-items:flex-start;
  justify-content: flex-end;
}
.success-content {
  width: 100%;
  border-radius: 0 0 5px 5px;
}
}
</style>
